<template>
  <div>
    <el-dialog
      top="6vh"
      width="850px"
      center
      :title="`${originalOrderDetailObj.orderId || ''} ( ${
        originalOrderDetailObj.id || ''
      } ) 原始下单信息`"
      :visible="originalOrderDetailObj.visible"
      @close="handleCancel()"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane
          v-for="item in dataList"
          :key="item.name"
          :label="item.name"
          :name="item.name"
        >
          <el-tag
            style="
              width: 100%;
              height: unset;
              overflow-x: auto;
              color: #333;
              font-size: 16px;
              padding: 0 15px;
            "
            size="mini"
            type="success"
          >
            <pre style="white-space: pre-wrap">{{
              isJsonString(item.data) ? JSON.parse(item.data) : item.data
            }}</pre>
          </el-tag>

          <i
            v-if="item.data"
            style="float: right; margin-top: 10px"
            @click="CopyTextToClipboard(item.data, `${item.name} 信息已复制`)"
            class="el-icon-document-copy cursorPointer"
          ></i>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import {
  getPayOriginOrderInfo, // 获取支付原始下单信息
  getWithdrawOriginOrderInfo, // 获取提现原始下单信息
} from "@/api/order";

export default {
  mixins: [mainCommon],
  props: ["originalOrderDetailObj"],
  data() {
    return {
      activeName: "request",
      dataList: [],
    };
  },
  watch: {
    originalOrderDetailObj(row) {
      if (row.visible) {
        if (row.order_type === "pay") {
          getPayOriginOrderInfo({
            orderId: this.originalOrderDetailObj.id,
          })
            .then((res) => {
              this.dataList = Object.keys(res.data).map((k) => {
                return { name: k, data: res.data[k] };
              });
            })
            .catch(() => {
              this.$notify.error("原始下单信息取得失败，请稍后再试");
            });
        } else if (row.order_type === "withdraw") {
          getWithdrawOriginOrderInfo({
            orderId: this.originalOrderDetailObj.id,
          })
            .then((res) => {
              this.dataList = Object.keys(res.data).map((k) => {
                return { name: k, data: res.data[k] };
              });
            })
            .catch(() => {
              this.$notify.error("原始下单信息取得失败，请稍后再试");
            });
        }
      }
    },
  },
  methods: {
    handleCancel() {
      this.activeName = "request";
      this.dataList = [];
      this.$emit("update:original-order-detail-obj", {});
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/OriginalOrderDetail.vue